export default __webpack_public_path__ + "static/media/work-item2.6edbc5bc.svg";